import $ from 'jquery'

export class Header {
  constructor($container) {
    this.$container = $container
    this.$window = $(window)

    this.handleLoadUpdateBackground()
  }

  handleLoadUpdateBackground(e) {
    let allBackgrounds = this.$container.data('backgrounds')

    if (!allBackgrounds || allBackgrounds.length === 0) {
      return
    }

    let indexBg = Math.floor(Math.random() * allBackgrounds.length);
    let currentBg = allBackgrounds[indexBg]

    if (currentBg['is_negative']) {
      this.$container.addClass('negative')
    } else {
      this.$container.removeClass('negative')
    }

    if (currentBg['desktop']['media_type'] === 'video') {
      this.addVideoToContainer(currentBg['desktop']['video'], 'desktop')
    }
    if (currentBg['desktop']['media_type'] === 'image') {
      this.$container.css('--bg-img-d', 'url(' + currentBg['desktop']['image'] + ')')
    }
    if (currentBg['desktop']['media_type'] === 'player') {
      this.addPlayerToContainer(currentBg['desktop']['player'], 'desktop')
    }

    if (currentBg['mobile']['media_type'] === 'video') {
      this.addVideoToContainer(currentBg['mobile']['video'], 'mobile')
    }
    if (currentBg['mobile']['media_type'] === 'image') {
      this.$container.css('--bg-img-m', 'url(' + currentBg['mobile']['image'] + ')')
    }
    if (currentBg['mobile']['media_type'] === 'player') {
      this.addPlayerToContainer(currentBg['mobile']['player'], 'mobile')
    }

    if (allBackgrounds[indexBg]['content']) {
      this.$container.find('.header-content').html(allBackgrounds[indexBg]['content'])
    }
  }

  addVideoToContainer(url, device) {
    this.$container.prepend(`<video autoplay loop muted playsinline class="header-video ${device}"><source src="${url}" type="video/mp4"></video>`)
  }

  addPlayerToContainer(iframe, device) {
    let $iframe = $(iframe)

    this.$container.prepend($iframe)

    let src = $iframe.attr('src')

    if (src.indexOf('?') !== -1) {
      src += '&'
    } else {
      src += '?'
    }
    src += 'autoplay=1&mute=1&loop=1&controls=0&modestbranding&disablekb=1&showinfo=0&rel=0&playsinline=1'

    $iframe.attr('src', src)
    $iframe.after('<div class="header-overlay"></div>')
    $iframe.wrap(`<div class="header-video iframe ${device}"></div>`)
  }
}
